export const MONO_KEY: string = 'v-mono';
export const ZOOM_KEY: string = 'v-zoom';
